export enum AnnouncementType {
  General = 0,
  Event = 1,
  RecurringEvent = 2,
  PrayerRequest = 3
}

export interface BaseAnnouncement {
  announcementId: number;
  announcementType: AnnouncementType;
  title: string;
  description: string;
  publishDate: string | null;
  expiryDate: string | null;
  metaData: string;
  createdAt: string;
  updatedAt: string;
}

export interface GeneralAnnouncement extends BaseAnnouncement {
  announcementType: AnnouncementType.General;
}

export interface EventAnnouncement extends BaseAnnouncement {
  announcementType: AnnouncementType.Event;
  startDateTime: string;
  endDateTime: string;
  location: string;
}

export interface RecurringAnnouncement extends BaseAnnouncement {
  announcementType: AnnouncementType.RecurringEvent;
  location: string;
  occurrences: RecurringEventOccurrence[];
}

export interface PrayerRequestAnnouncement extends BaseAnnouncement {
  announcementType: AnnouncementType.PrayerRequest;
  requestorName: string;
  requestDetails: string;
  urgent: boolean;
}

export type Announcement =
  | GeneralAnnouncement
  | EventAnnouncement
  | RecurringAnnouncement
  | PrayerRequestAnnouncement;

export interface EventDetail {
  announcementId: number;
  startDateTime: string;
  endDateTime: string;
  location: string;
}

export interface RecurringEventDetail {
  announcementId: number;
  location: string;
  occurrences: RecurringEventOccurrence[];
}

export interface RecurringEventOccurrence {
  occurrenceId: number;
  announcementId: number;
  startDateTime: string;
  endDateTime: string;
  metaData: string;
}

export interface AnnouncementPrayerRequest {
  announcementId: number;
  requestorName: string;
  requestDetails: string;
  urgent: boolean;
}

export interface CreateAnnouncementDto {
  announcementType: AnnouncementType;
  title: string;
  description: string;
  publishDate?: string;
  expiryDate?: string;
  metaData?: string;
}

export interface UpdateAnnouncementDto extends CreateAnnouncementDto {
  announcementId: number;
} 